import { all, fork } from 'redux-saga/effects'

// App
import AppSagas from './app/sagas'


function* loop() {
  yield all([AppSagas.loop()])
}

export default function* rootSaga() {
  yield fork(loop)
}
